import { transport } from 'config/transport';

export function callApiCheckAccessCode(id, accessCode) {
    return transport.get(`/mamnon/classes/${id}/check-access-code`, { params: { accessCode } });
}
